<mx-confirmed-credential-form-field [fieldName]="fieldName" [formGroup]="formGroup" [credentialLabel]="passwordLabel"
                                    [confirmationLabel]="confirmationLabel" mismatchErrorMessage="Passwords do not match."
                                    [maxLength]="maximumPasswordLength" [showCredentialValidationErrors]="false">
  <div credentialRequirements class="grid grid-cols-1 sm:grid-cols-2 px-2 mt-1 mb-8">
    @for (requirement of requirements; track requirement.label) {
      @let untouched = passwordControl.untouched;
      @let satisfied = isRequirementSatisfied(requirement);

      <!-- Don't show error colors until the user blurs the password field. -->
      @let unsatisfied = passwordControl.touched && !satisfied;

      <div class="flex items-center gap-x-[0.125rem] h-8">
        <mat-icon class="material-icons-outlined" [class.text-on-surface-variant]="untouched" [class.text-success]="satisfied" [class.text-error]="unsatisfied">
          {{ satisfied ? 'check_circle' : 'close' }}
        </mat-icon>

        <span class="text-title-medium" [class.text-on-surface]="untouched" [class.text-success]="satisfied" [class.text-error]="unsatisfied">
          {{ requirement.label }}
        </span>
      </div>
    }
  </div>
</mx-confirmed-credential-form-field>
